export function stageDurations(deal, transitions, now = Date.now()) {
  if (!deal) return {}
  const end = deal.status !== 'aberto' && deal.closed_at ? Math.min(now, Date.parse(deal.closed_at)) : now
  const events = transitions.filter((event) => Number.isFinite(Date.parse(event.occurred_at)) && Date.parse(event.occurred_at) <= end).sort((a, b) => Date.parse(a.occurred_at) - Date.parse(b.occurred_at))
  const totals = {}
  let stageId = events.length ? events[0].from_stage_id : deal.stage_id
  let start = Date.parse(deal.created_at)
  const add = (id, duration) => { if (id && Number.isFinite(duration)) totals[id] = (totals[id] || 0) + Math.max(0, duration) }
  for (const event of events) {
    const time = Date.parse(event.occurred_at)
    add(stageId, time - start)
    stageId = event.to_stage_id
    start = time
  }
  add(stageId, end - start)
  return Object.fromEntries(Object.entries(totals).map(([id, milliseconds]) => [id, Math.floor(milliseconds / 86400000)]))
}
